export default __webpack_public_path__ + "static/vaucluse-naturellement-Provence-4ccdc4a80f8e7b76769e48b934cc1fdb.png";